// combatpro/runtime/TemplatesPanel.js
//
// Combat PRO - Encounter Template library UI (on the Encounter Dashboard).
//
// Reusable prepared encounters, separate from the 12 live slots and account-backed
// through the same encounter-state document. Save the active encounter as a template
// (preparation only; live runtime stripped), then create a fresh encounter from a
// template into the first empty unlocked slot. No optional chaining, no nullish
// coalescing, no em dash.

import React, { useContext } from 'react';
import { CombatContext } from '../contexts/CombatContext';

function nz(v) { return (v === null || typeof v === 'undefined') ? '' : v; }

function TemplatesPanel() {
  const ctx = useContext(CombatContext);
  const templates = Array.isArray(ctx.state.templates) ? ctx.state.templates : [];

  return (
    <div className="vi-xo-panel vi-tpl-panel">
      <div className="vi-xo-title">Encounter Templates</div>
      <p className="vi-eb-help">Reusable prepared encounters, saved to your account and separate from the 12 live slots. Saving captures preparation only (monsters, brief, groups, zones); live combat runtime is not copied.</p>
      <div className="vi-eb-chiprow">
        <button type="button" className="vi-tr-primary" onClick={ctx.saveActiveAsTemplate}>Save current encounter as template</button>
      </div>
      {templates.length ? templates.map(function (tpl) {
        var count = Array.isArray(tpl.monsters) ? tpl.monsters.filter(function (m) { return m && ((m.customName && String(m.customName).trim()) || (m.selectedMonster && String(m.selectedMonster).trim())); }).length : 0;
        return (
          <div className="vi-tpl-row" key={tpl.id}>
            <input className="vi-tr-input vi-eb-grow" value={nz(tpl.name)} onChange={function (e) { ctx.renameTemplate(tpl.id, e.target.value); }} />
            <span className="vi-tpl-meta">{count} monster{count === 1 ? '' : 's'}</span>
            <button type="button" className="vi-tr-btn" onClick={function () { ctx.createEncounterFromTemplate(tpl.id); }}>Create encounter</button>
            <button type="button" className="vi-tr-mini vi-tr-mini-danger" title="Delete template" onClick={function () { if (window.confirm('Delete template "' + (tpl.name || 'Template') + '"?')) { ctx.deleteTemplate(tpl.id); } }}>{'✖'}</button>
          </div>
        );
      }) : <div className="vi-tr-empty">No templates saved yet. Prepare an encounter, then save it here to reuse it later.</div>}
    </div>
  );
}

export default TemplatesPanel;
